export function setCookie(name: string, value: string, iDay: number) {
  const oDate = new Date()
  oDate.setDate(oDate.getDate() + iDay)
  document.cookie = name + '=' + value + ';expires=' + oDate + ':path=/;domain=' + getRootHost()
}

export function getCookie(name: string) {
  const arr = document.cookie.split('; ')
  for (let i = 0; i < arr.length; i++) {
    const arr2 = arr[i].split('=')
    if (arr2[0] === name) {
      return arr2[1]
    }
  }
  return ''
}

function getRootHost() {
  const host = document.domain
  if (host.includes('foxrenderfarm.com')) {
    return '.foxrenderfarm.com'
  } else if (host.includes('renderbus.com')) {
    return '.renderbus.com'
  }
}
